import { render, staticRenderFns } from "./EmailNotification.vue?vue&type=template&id=7856ec59"
import script from "./EmailNotification.vue?vue&type=script&lang=js"
export * from "./EmailNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports